import { render, staticRenderFns } from "./reserveCatalogManageList.vue?vue&type=template&id=2b1cffe0&scoped=true"
import script from "./reserveCatalogManageList.vue?vue&type=script&lang=js"
export * from "./reserveCatalogManageList.vue?vue&type=script&lang=js"
import style0 from "./reserveCatalogManageList.vue?vue&type=style&index=0&id=2b1cffe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1cffe0",
  null
  
)

export default component.exports